export const auth0options = {
  theme: {
    logo: 'https://demo.jsnorm.com/react/strikingdash/static/media/Logo_Dark.9ef25a33.svg',
    primaryColor: '#00CC61',
    labeledSubmitButton: true,
  },
  avatar: null,
  rememberLastLogin: false,
  auth: {
    redirect: false,
  },
  languageDictionary: {
    title: 'Sign in with Auth0',
  },
  popupOptions: { width: 460, height: 506, left: 200, top: 300 },
};
